import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const averageStopsPerRouteState = (state: RootState) =>
  state.scene.dashboard.averageStopsPerRouteState;

export const getAverageStopsPerRouteDrillDownViewState = createSelector(
  averageStopsPerRouteState,
  ({ viewState }) => viewState
);

export const getAverageStopsPerRouteDrillDownTotalFilteredRoutes = createSelector(
  averageStopsPerRouteState,
  ({ totalFilteredRoutes }) => totalFilteredRoutes
);

export const getAverageStopsPerRouteDrillDownTotalRoutes = createSelector(
  averageStopsPerRouteState,
  ({ totalRoutes }) => totalRoutes
);

export const getAverageStopsPerRouteDrillDownConfiguration = createSelector(
  averageStopsPerRouteState,
  ({ configuration }) => configuration
);

export const isAverageStopsPerRouteDrillDownLoading = createSelector(
  averageStopsPerRouteState,
  ({ loading }) => loading
);
